export const GUI_STATE_UPDATE_MODAL = 'GUI_STATE_UPDATE_MODAL';
//# sourceMappingURL=types.js.map